import { render } from "./KeywordSetting.vue?vue&type=template&id=34d24871&scoped=true"
import script from "./KeywordSetting.vue?vue&type=script&lang=js"
export * from "./KeywordSetting.vue?vue&type=script&lang=js"

import "./KeywordSetting.vue?vue&type=style&index=0&id=34d24871&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34d24871"]])

export default __exports__